<template>
  <vx-card no-shadow>

    <div class="vx-row">
      <div class="vx-col w-full">
        <h4>Configuración de Caja</h4>
      </div>
    </div>
   
    <!-- <div class="vx-row mt-4">
      <div class="vx-col w-full">
        <h6>Condiguración de Moneda</h6>
      </div>
      <div class="vx-col w-full">
        <div class="vx-row flex justify-center py-3">
          <vs-input label-placeholder="Nombre" class="mr-3" v-model="monName"/>
          <vs-input label-placeholder="Símbolo" class="ml-3" v-model="monSym"/>
        </div>
      </div>
    </div> -->
    <div class="vx-row">
      <div class="vx-col w-full mt-6">
        <h5>Precio Predefinido de Consulta</h5>
      </div>
      <div class="vx-col w-full my-6">
        <div class="vx-row justify-center my-6" >
          <h4 class="mr-4 mt-3"><strong>Precio: </strong></h4>
          <h3 class="inline mr-1 mt-2">{{monSym}}</h3>
          <vs-input  class="ml-3" type="number" step="0.01" :disabled="!editting" v-model="defaultPrice"/>
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-end justify-end" v-if="!isSecretary">
      <vs-button class="mr-2" color="primary" v-if="editting" @click="changePrice">Guardar Cambios</vs-button>
      <vs-button class="mr-2" color="warning" v-if="!editting" @click="editting = !editting">Editar</vs-button>
      <vs-button class="mr-2" color="danger" v-if="editting" @click="editting = !editting">Cancelar</vs-button>

    </div>
  </vx-card>
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  data () {
    return {
      monName: 'Quetzales',
      monSym: 'Q',
      defaultPrice: null,
      defaulIVA: 12,
      editting: false,
      userData: {},
      isSecretary: false,
      activeDoctorData: null
    }
  },
  methods: {
    showAlert(color, title, text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text,
      });
    },
    changePrice(){
      const metaUpdateUser = {
        id: this.userData.id,
        meta: {...this.userData.meta, ...{'defaultPrice': this.defaultPrice}}
      };
      this.$store.dispatch('evolugy/updateUser', metaUpdateUser);
      this.editting = false;

      this.showAlert(
            "success",
            "Precio Modificado",
            "Precio modificado éxitosamente!"
          );
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  beforeMount(){
    if(this.activeUserInfo.role !== "doctor" ){
    console.log('Es SECRE');
      this.isSecretary = true;
      this.$store.dispatch('getDoctorDataById', sessionStorage.getItem('activeDoctorId')).then(response=>{
        console.log('DOCTOR: ',response);
        this.activeDoctorData = JSON.parse(JSON.stringify(response.data.data.user));
        if(this.activeDoctorData.meta && this.activeDoctorData.meta.defaultPrice){
           this.defaultPrice = this.activeDoctorData.meta.defaultPrice;
          this.defaultPrice = parseFloat(this.defaultPrice).toFixed(2);
        } else {
          if(this.activeUserInfo.meta.defaultPrice){
            this.defaultPrice = parseFloat(this.activeUserInfo.meta.defaultPrice).toFixed(2);
          } else {
            this.defaultPrice = 250.00;
          }
          
        }
       
      }, error => {
        console.error(error);
      });
    } else {
      this.isSecretary = false;
    }
  },
  mounted(){
    
  },
  beforeCreate(){
     this.userData = JSON.parse(JSON.stringify(this.$store.state.AppActiveUser))
  },
  created() {
     
  },
  
}
</script>
